import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Routers from './routers';
import { getUserLang } from './utils/commom';
import { ROUTE_PATHS } from './constants/routePaths';
import i18n from "./i18n"; // 引入 i18n 配置

const TITLE_KEY_BY_PATH = {
  [ROUTE_PATHS.SERVICE]: 'text7',
  [ROUTE_PATHS.PLAN]: 'text105',
  [ROUTE_PATHS.DIFF]: 'text54',
  [ROUTE_PATHS.REGION]: 'text105',
  [ROUTE_PATHS.SIM]: 'text118',
};

// 主包执行时立即按入口路由设置标题,避免 App 标题栏在页面挂载前拿 URL 兜底
const applyInitialTitle = () => {
  if (window.location.pathname === ROUTE_PATHS.ERROR) {
    document.title = '70mai';
    return;
  }
  document.title = i18n.t(TITLE_KEY_BY_PATH[window.location.pathname] || 'text7');
};
// import reportWebVitals from './reportWebVitals';

const RTL_LANGS = ['ar'];

const applyDocumentDir = (lang) => {
  const nextLang = lang || 'en';
  document.documentElement.lang = nextLang;
  document.documentElement.dir = RTL_LANGS.includes(nextLang) ? 'rtl' : 'ltr';
};

let lang = getUserLang();
i18n.changeLanguage(lang);
applyDocumentDir(lang);
applyInitialTitle();
i18n.on('languageChanged', applyDocumentDir);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Routers />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
